import { apiPostLoginIn, apiPostLoginOut } from '@/api/login'
import { LoginFormData, UserState } from '@/types'
import { localStorage } from '@/utils/storage'
import { defineStore } from 'pinia'

const useUserStore = defineStore({
  id: 'user',
  state: (): UserState => ({
    token: localStorage.get('token') || '',
    userInfo: localStorage.get('userInfo') || {},
    roles: localStorage.get('roles') || [],
  }),
  actions: {
    async RESET_STATE() {
      this.$reset()
    },
    /**
     * 用户登录请求
     * @param params 登录用户信息
     *  username: 用户名
     *  password: 密码
     */
    login(params: LoginFormData) {
      const { username, password } = params
      return new Promise((resolve, reject) => {
        apiPostLoginIn({
          username: typeof username === 'number' ? username : username.trim(),
          password: password,
        })
          .then((response: any) => {
            const { token, roleCodeList, ...userInfo } = response.data
            localStorage.set('token', token)
            localStorage.set('userInfo', userInfo)
            localStorage.set('roles', roleCodeList)
            this.token = token
            this.userInfo = userInfo
            this.roles = roleCodeList
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    /**
     *  注销
     */
    logout() {
      return new Promise((resolve, reject) => {
        apiPostLoginOut()
          .then(() => {
            localStorage.clear() // 清除浏览器全部缓存
            this.RESET_STATE()
            resolve(null)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    /**
     * 清除 Token
     */
    resetToken() {
      return new Promise((resolve) => {
        localStorage.remove('token')
        this.RESET_STATE()
        resolve(null)
      })
    },
  },
})

export default useUserStore
